export const getSheetNameFromDateRange = (startDate: Date, endDate: Date, sheetType: string) => {
  const startDateString = startDate.toISOString().split("T")[0];
  const endDateString = endDate.toISOString().split("T")[0];
  return `${startDateString}_${endDateString}_${sheetType}`;
};
